import styled from 'styled-components';

const ItemsContent = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
  padding-left: 20px;
`;

export default ItemsContent;
